@if (modalState$ | async; as modalState) {
  @if (modalState.ordersOverviewModal.open) {
    <app-orders-overview-modal
      (dismiss)="closeModal('ordersOverviewModal')"
      [ifs]="(ifs$ | async)!"
    ></app-orders-overview-modal>
  }
  @if (modalState.installationReportModalV2.open) {
    <app-installation-report-modal-v2
      (dismiss)="closeModal('installationReportModalV2')"
      [ifs]="(ifs$ | async)!"
      [deliveryOrderId]="
        modalState.installationReportModalV2!.data?.leadId ??
        modalState.installationReportModalV2!.data?.sourceKey
      "
      [multiPointData]="modalState.installationReportModalV2.multiPoint"
    ></app-installation-report-modal-v2>
  }
  @if (modalState.multiPointModal.open) {
    <app-multi-point-modal
      [ifs]="(ifs$ | async)!"
      (dismiss)="closeModal('multiPointModal')"
      [multiPointData]="modalState.multiPointModal.multiPoint!"
    ></app-multi-point-modal>
  }
}
